import { render } from "./FalseAir.vue?vue&type=template&id=6f7e1e64&scoped=true"
import script from "./FalseAir.vue?vue&type=script&lang=js"
export * from "./FalseAir.vue?vue&type=script&lang=js"

import "./FalseAir.vue?vue&type=style&index=0&id=6f7e1e64&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7e1e64"]])

export default __exports__